import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { fetchWalkthroughSales } from "../../../Redux/Dashboard/External/SalesDemo/Actions/GetSalesWalkthroughAction";
import { updateSalesWalkthorughStatusAct } from "../../../Redux/Dashboard/External/SalesDemo/Actions/UpdateSalesWalkthorughActions";
import Swal from "sweetalert2";
import { IoChevronBack } from "react-icons/io5"; // ✅ Use a modern back arrow
import LoadingScreen from "../../../ReusableBlocks/LoadingScreen";

const Onboarding = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [step, setStep] = useState(0);

    const { salesWalkthrough, loading, error } = useSelector((state) => state.GetSalesWalkthrough);
    const { updating, updateError } = useSelector((state) => state.UpdateSalesWalkthrough);
    const currentUser = useSelector((state) => state.auth.currentUser);

    // ✅ Detect if user visited from another page
    const searchParams = new URLSearchParams(location.search);
    const isRevisit = searchParams.get("from") === "menu"; // Checks if "?from=menu" is in the URL

    useEffect(() => {
        dispatch(fetchWalkthroughSales());
    }, [dispatch]);

    useEffect(() => {
        if (updateError) {
            Swal.fire({
                title: "Error!",
                text: updateError,
                icon: "error",
                confirmButtonText: "Retry",
            });
        }
    }, [updateError]);

    const handleNext = () => {
        if (step < salesWalkthrough.length - 1) {
            setStep(step + 1);
        } else if (!isRevisit) {
            dispatch(updateSalesWalkthorughStatusAct(navigate));
        } else {
            navigate(-1); // 🔹 Go back if revisiting
        }
    };

    const handleStepClick = (index) => {
        setStep(index);
    };

    return (
        <>

            {updating && <LoadingScreen text="Loading" />}

            {isRevisit && (
          
            <div className="sales-onboard-navbar">
                <div className="back-container" onClick={() => navigate(-1)}>
                    <IoChevronBack className="back-arrow" />
                    <span className="back-text">Back</span>
                </div>
            </div>
             )}

            <div className="sales-onboard-container">
                {/* ✅ Modern back arrow with spacing */}
                <h2 className="sales-onboard-title">
                   Let's have a quick walkthrough
                </h2>

                <div className="sales-onboard-content">
                    {loading ? (
                        <p>Loading Walkthrough...</p>
                    ) : error ? (
                        <p>Error: {error}</p>
                    ) : salesWalkthrough && salesWalkthrough.length > 0 ? (
                        <AnimatePresence mode="wait">
                            <motion.div
                                key={step}
                                initial={{ opacity: 0, x: 50 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: -50 }}
                                transition={{ duration: 0.5 }}
                                className="sales-onboard-slide"
                            >
                                <img
                                    src={salesWalkthrough[step]}
                                    alt={`Onboarding Step ${step + 1}`}
                                    className="sales-onboard-image"
                                />
                            </motion.div>
                        </AnimatePresence>
                    ) : (
                        <p>No walkthrough available.</p>
                    )}
                </div>

                {/* ✅ Step Indicator & Navigation Button */}
                {salesWalkthrough && salesWalkthrough.length > 0 && (
                    <div className="sales-onboard-bottom">
                        <div className="sales-onboard-indicator">
                            {salesWalkthrough.map((_, index) => (
                                <div
                                    key={index}
                                    className={`sales-onboard-step ${step === index ? "active" : ""}`}
                                    onClick={() => handleStepClick(index)}
                                />
                            ))}
                        </div>

                        <motion.button
                            onClick={handleNext}
                            className="sales-onboard-button"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                        >
                            {step < salesWalkthrough.length - 1 ? "Next" : isRevisit ? "Back" : "Get Started"} &rsaquo;
                        </motion.button>
                    </div>
                )}
            </div>
        </>
    );
};

export default Onboarding;
